/* Flips a card carousel or product gallery to its back on an add. Driven by
   Horizon's cart:lines-update, not [data-added]: that attribute is skipped on
   the puppet click the sticky bar uses, and says nothing about the outcome. */
(function () {
  'use strict';

  const TURN = 500;
  const HOLD = 1400;

  /* Pending timers per plate in the air, so a second add updates the count on
     the back instead of restarting the turn. */
  const running = new WeakMap();

  /* The cart chain reports its own failures; a rejection here only means there
     is no plate to turn. */
  function ignore() {}

  function writeQuantity(back, count) {
    const line = back.querySelector('[data-bq-flip-qty]');
    if (!line || !count) return;
    const form = back.getAttribute(count === 1 ? 'data-qty-one' : 'data-qty-other');
    if (!form) return;
    // Only the two plural forms are translated: Liquid cannot know the count,
    // so the number is swapped into the form that the count selects.
    line.textContent = count === 1 ? form : form.replace(/\p{Nd}+/u, String(count));
  }

  function land(host) {
    running.delete(host);
    host.classList.remove('is-bq-arm', 'is-bq-turn');
    // Replay the corner count bump: it ran out of sight while the plate was
    // turned away.
    const badge = host.querySelector('.bq-card__count');
    if (!badge || badge.hidden) return;
    badge.classList.remove('bq-bump');
    void badge.offsetWidth;
    badge.classList.add('bq-bump');
  }

  function turn(host) {
    const state = { timers: [] };
    running.set(host, state);
    host.classList.add('is-bq-arm');
    // The resting transform must compute before the turned one replaces it; a frame
    // would do it too, but not in a hidden tab, where the timers would run ahead.
    void host.offsetWidth;
    host.classList.add('is-bq-turn');
    state.timers.push(setTimeout(function () {
      host.classList.remove('is-bq-turn');
    }, TURN + HOLD));
    state.timers.push(setTimeout(function () {
      land(host);
    }, TURN + HOLD + TURN));
  }

  /* Add failed: bring the plate back rather than let it hold a count the cart
     cannot confirm. */
  function recall(host) {
    const state = running.get(host);
    if (!state) return;
    state.timers.forEach(clearTimeout);
    host.classList.remove('is-bq-turn');
    state.timers = [setTimeout(function () { land(host); }, TURN)];
  }

  function start(host, count) {
    const back = host.querySelector('[data-bq-flip-back]');
    if (!back) return;
    writeQuantity(back, count);
    if (running.has(host)) return;
    turn(host);
  }

  function quantityOf(detail) {
    const productId = Number(detail && detail.productId);
    const items = (detail && detail.items) || [];
    let total = 0;
    for (let i = 0; i < items.length; i += 1) {
      if (items[i].product_id === productId) total += items[i].quantity;
    }
    return total;
  }

  function onCartLinesUpdate(event) {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const promise = event.promise;
    const awaited = promise && typeof promise.then === 'function';

    // Quick-add sheet: it closes on this same promise, so the plate to turn is
    // the card behind it, found back by product id.
    if (target.closest('quick-add-dialog')) {
      if (!awaited) return;
      promise
        .then(function (resolved) {
          const detail = resolved && resolved.detail;
          if (!detail || detail.didError || !detail.productId) return;
          const card = document.querySelector('.bq-card[data-product-id="' + detail.productId + '"]');
          if (card) start(card, quantityOf(detail));
        })
        .catch(ignore);
      return;
    }

    // A card, or the product page whose only plate is the gallery.
    const host = target.closest('.bq-card') || document.querySelector('[data-bq-flip-plate]');
    if (!host) return;

    start(host, 0);
    if (!awaited) return;
    promise
      .then(function (resolved) {
        const detail = resolved && resolved.detail;
        if (detail && detail.didError) {
          recall(host);
          return;
        }
        const back = host.querySelector('[data-bq-flip-back]');
        if (back) writeQuantity(back, quantityOf(detail));
      })
      .catch(ignore);
  }

  document.addEventListener('shopify:cart:lines-update', onCartLinesUpdate);
})();
